import { render, staticRenderFns } from "./fullname.vue?vue&type=template&id=c1ee57bc&scoped=true"
import script from "./fullname.vue?vue&type=script&lang=js"
export * from "./fullname.vue?vue&type=script&lang=js"
import style0 from "./fullname.vue?vue&type=style&index=0&id=c1ee57bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ee57bc",
  null
  
)

export default component.exports